import { StyleSheet } from 'react-native';

import {
    heightPercentageToDP,
    isWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    content: {
        paddingRight: isWeb ? 60 : 44,
    },
    closeButton: {
        position: 'absolute',
        top: 28,
        right: 44,
        zIndex: 1,
        padding: 10,
    },
    nextEpisodeContainer: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginBottom: 40,
    },
    nextLabel: {
        marginBottom: isWeb ? 8 : 2,
        textTransform: 'uppercase',
    },
    metadata: {
        marginBottom: isWeb ? 8 : 4,
        maxWidth: 300,
    },
    metadataContainer: {
        flexDirection: 'column',
        marginRight: 30,
        marginBottom: 30,
        alignItems: 'flex-end',
        textAlignVertical: 'center',
    },
    imageContainer: {
        width: widthPercentageToDP(230, 200, 200),
        height: heightPercentageToDP(120),
        borderRadius: 10,
        borderColor: '#FFFFFF',
        borderWidth: isWeb ? 2 : 0,
        overflow: 'hidden',
    },
    image: {
        width: '100%',
        height: '100%',
    },
    imageHovered: {
        borderWidth: 4,
    },
});
